// JavaScript Document
//components/configuration/standard/forms/MaxDisplaySpeed.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function MaxDisplaySpeed(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, value, onChange} = props;
	//locally stored/copied variables
	const [cid, setCid] = React.useState(0);
	//local state varialbes user will change
	const [maxSpeed, setMaxSpeed] = React.useState(99);
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			//console.log('config has changed');
			setCid(id);
			setMaxSpeed(value);
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Handle update parent if onChange is provided
	const handleUpdateParent = (newVal) => {
		if(onChange){
			console.log('Updating parent');
			onChange(newVal);
		}
	}
	

	
	//handle change timing value
	const handleChangeValue = (e) => {
		//let setting = e.target.name;
		let maxValue = parseInt(e.target.value);
		
		//clean the value
		if(isNaN(maxValue) || maxValue < 0){
			maxValue = 0;
		} else if(value > 255){
			maxValue = 255;
		}
		setMaxSpeed(maxValue);
		handleUpdateParent(maxValue);
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title="Maximum Display Speed" />
	  		<CardContent className={classes.advancedContent}>
	  				<TextField 
							id="maxDisplaySpeed" 
							name="maxTwoDisplaySpeed"
							label="Speed"
							value={maxSpeed.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'255', step:'5', style: {textAlign:'center'}}}
					/>
	  		</CardContent>
	  	</Card>
  );
}
